const USERS_API_REQUEST = "USERS/API_REQUEST";
const USERS_API_SUCCESS = "USERS/API_SUCCESS";
const USERS_API_FAILED = "USERS/API_FAILED";
const CUSTOMERS_API_REQUEST = "CUSTOMERS/API_REQUEST";
const CUSTOMERS_API_SUCCESS = "CUSTOMERS/API_SUCCESS";
const CUSTOMERS_API_FAILED = "CUSTOMERS/API_FAILED";

export { USERS_API_REQUEST, USERS_API_SUCCESS, USERS_API_FAILED, CUSTOMERS_API_REQUEST, CUSTOMERS_API_SUCCESS, CUSTOMERS_API_FAILED }